import { useEffect, useState } from "react";
import { useNavigate, useParams} from "react-router-dom";
import { a } from "../services/axiosInstance";
import { HOME } from "../services/consts";
import Error from "./Error";

function UpdateCardForm() {

    const {id} = useParams();
    const [content, setContent] = useState("");
    const navigate = useNavigate();
    const [isError, setIsError] = useState(false);


    useEffect(() => {
        async function fetchPost() {
            try {
                const res = await a.get(`items/detail/${id}/`);
                setContent(res.data.content);
            } catch (e) {
                setIsError(true);
                console.log(e);
            }            
        }
        fetchPost();
    }, [id]);
    
    if (isError) {
        return <Error />
    }

    async function handleSubmit(e) {
        e.preventDefault();
        try {
            await a.put(`items/post/update/${id}/`, {content});
            navigate(HOME);
        } catch (err) {
            console.log(err);
        }
    }

    return(
        <form className="form" onSubmit={handleSubmit}>
            <textarea 
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="form-control pattern" 
            placeholder="Start typing here.."
            ></textarea>
            <button className="submit-primary-button" type="submit">SAVE</button>
        </form>
    );
}

export default UpdateCardForm;